
export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white">
      <div className="container mx-auto px-6 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="md:col-span-2">
            <div className="flex items-center space-x-3 mb-4">
              <div className="w-10 h-10 bg-blue-600 rounded-lg flex items-center justify-center">
                <span className="text-white font-bold text-lg">JB</span>
              </div>
              <div>
                <h3 className="text-xl font-bold" style={{ fontFamily: '"Pacifico", serif' }}>
                  JB Technologies
                </h3>
                <p className="text-gray-400 text-sm">UX Design Excellence</p>
              </div>
            </div>
            <p className="text-gray-400 mb-4 max-w-md">
              Transforming complex business challenges into intuitive user experiences across diverse industries. 
              We specialize in enterprise-grade UX solutions that drive digital transformation.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer">
                <i className="ri-twitter-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer">
                <i className="ri-dribbble-fill text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-blue-600 transition-colors cursor-pointer">
                <i className="ri-behance-fill text-lg"></i>
              </a>
            </div>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Services</h4>
            <ul className="space-y-2 text-gray-400">
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">UX/UI Design</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">User Research</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Design Strategy</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Prototyping</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Design Systems</a></li>
            </ul>
          </div>
          
          <div>
            <h4 className="font-semibold mb-4">Industries</h4>
            <ul className="space-y-2 text-gray-400">
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Finance & Insurance</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Aerospace & Defense</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Healthcare</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Enterprise Software</a></li>
              <li><a href="#" className="hover:text-white transition-colors cursor-pointer">Government</a></li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-8 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">
            © 2024 JB Technologies. All rights reserved.
          </p>
          <div className="flex items-center space-x-6 mt-4 md:mt-0">
            <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">Privacy Policy</a>
            <a href="#" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">Terms of Service</a>
            <a href="https://readdy.ai/?origin=logo" className="text-gray-400 hover:text-white text-sm transition-colors cursor-pointer">Website Builder</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
